import { App } from 'vue';

export class Geolocalization {

    private static _instance: Geolocalization | null = null;

    static getInstance(): Geolocalization {
        if (!Geolocalization._instance) {
            Geolocalization._instance = new Geolocalization();
        }
        return Geolocalization._instance;
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {
    }

    getCurrentLocation(): Promise<GeolocationPosition> {
        return new Promise<GeolocationPosition>((resolve, reject) =>{
            if(!('geolocation' in navigator)) {
                reject('no geolocation available');
            }

            navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    resolve(position);
                },
                (error: GeolocationPositionError) => {
                    reject(error);
                }
            )
        });
      
    }

}

export default {
    install(app: App) {
        app.config.globalProperties.$geolocalization = Geolocalization.getInstance();
    }
}